<template>
    <div class="form pwds-form">
        <div v-if="!!errorMessage" class="alert alert-danger">
            <i class="fa fa-exclamation-triangle mr-2"></i>
            {{ errorMessage }}
        </div>

        <PassordFields @passwordValidity="onPasswordValidity" />

        <Btn class="primary reverse block mt-4"
             @click.native.prevent="saveForm">{{ $t('global.save') }}
        </Btn>

    </div>
</template>

<script>
    import Btn from '@/components/ui/Button'
    import axios from 'axios'
    import API from '@/services/API'
    import Utils from '@/services/utils'
    import PassordFields from "@/components/settings/PasswordFields.vue";

    export default {
        name: 'PasswordForm',
        components: {
            PassordFields,
            Btn
        },
        data() {
            return {
                password: '',
                passwordConfirm: '',
                isPasswordValid: false,
                errorMessage: null
            }
        },
        methods: {
            onPasswordValidity: function(password) {
                this.isPasswordValid = password.isValid;
                if (password.isValid) {
                    this.password = password.pwd;
                    this.passwordConfirm = password.pwdConfirm;
                } else {
                    this.password = '';
                    this.passwordConfirm = '';
                }
            },
            saveForm: function () {
                if (!this.isPasswordValid) return;

                this.errorMessage = null
                window.Vfc.$refs.loading.show();

                var passwordObj = {
                    auth: {
                        provider: 'password',
                        secret: this.password,
                    }
                }

                axios.put(API.endpoints.user.changePassword, passwordObj)
                    .then(response => {
                        window.Vfc.$refs.messages.sendMessage('success', Utils.t('settings.passwordSuccess'));
                        window.Vfc.$refs.modal.hide();
                        window.Vfc.$refs.loading.hide();

                    })
                    .catch(error => {
                        // TODO: Vérifier erreur back
                        if (error.response != null && !!error.response?.data?.errors) {
                            this.errorMessage = Utils.te(`login.errors.${errorCode}`) ? Utils.t(`login.errors.${errorCode}`) : Utils.t(`login.errors.default`);
                        } else {
                            this.errorMessage = Utils.t(`login.errors.default`);
                        }
                        window.Vfc.$refs.loading.hide();
                    })


            },
        },
    }
</script>
